import {
  INTEGRATION_TYPES,
  type IntegrationDefinition,
  type IntegrationEndpointInfo,
} from '../types'

export const DEFAULT_SHAREPOINT_CONFIG = {}

const SHAREPOINT_ENDPOINTS: IntegrationEndpointInfo[] = [
  {
    name: 'Search SharePoint',
    method: 'POST',
    description: 'Search SharePoint for documents, sites, lists, and list items',
    toolName: 'search_sharepoint',
  },
  {
    name: 'Get Drive Item',
    method: 'GET',
    description: 'Retrieve the content of a specific SharePoint drive item by drive and item ID',
    toolName: 'get_drive_item',
  },
]

export const sharepointIntegration: IntegrationDefinition = {
  id: INTEGRATION_TYPES.SHAREPOINT,
  title: 'SharePoint',
  defaultConnectionName: 'SharePoint',
  logo: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/sharepoint-logo.png',
  icon: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/sharepoint-icon.png',
  cardDescription:
    'Connect to Microsoft SharePoint via the Graph API to search and retrieve documents and site content.',
  modalDescription: 'Connect to Microsoft SharePoint via the Microsoft Graph API using OAuth 2.0.',
  formFields: [
    {
      name: 'authMode',
      label: 'Access Mode',
      placeholder: 'Select access mode',
      required: true,
      type: 'select',
      defaultValue: 'delegated',
      options: [
        {
          value: 'delegated',
          label: 'Delegated (per-user) \u2014 Recommended',
          helperText:
            'Each user\u2019s searches run under their own Microsoft identity, so they only see SharePoint content they already have permission to access. Users connect their Microsoft account once. Available only for the internal Assistant.',
        },
        {
          value: 'shared',
          label: 'Shared (single service identity)',
          helperText:
            'All searches run under a single service account, so every user sees the same SharePoint content regardless of their individual permissions.',
        },
      ],
    },
    {
      name: 'tenantId',
      label: 'Tenant ID',
      placeholder: 'e.g., xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
      helperText: 'Your Azure Active Directory tenant ID',
      required: true,
      type: 'text',
    },
    {
      name: 'clientId',
      label: 'Client ID',
      placeholder: 'e.g., xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
      helperText: 'The application (client) ID from your Azure app registration',
      required: true,
      type: 'text',
    },
    {
      name: 'clientSecret',
      label: 'Client Secret',
      placeholder: 'Enter your client secret',
      helperText: 'The client secret from your Azure app registration',
      required: true,
      type: 'password',
    },
  ],
  apiConfig: {
    createEndpoint: '/integrations/generate-sharepoint-integration/',
    buildPayload: (formData, _config, _organizationId, organizationIdentityId) => ({
      organization_identity_id: organizationIdentityId,
      tenant_id: formData.tenantId,
      client_id: formData.clientId,
      client_secret: formData.clientSecret,
      connection_name: formData.connectionName || 'SharePoint',
      auth_mode: formData.authMode || 'delegated',
    }),
    authTokenName: 'oauth2',
    buildTestCredentials: (formData) => ({
      tenant_id: formData.tenantId,
      client_id: formData.clientId,
      client_secret: formData.clientSecret,
      auth_mode: formData.authMode || 'delegated',
    }),
  },
  defaultConfig: { ...DEFAULT_SHAREPOINT_CONFIG },
  endpoints: SHAREPOINT_ENDPOINTS,
}
